<template>
    <div>
        <app-erros-box :erros="erros2" v-if="erros2.length > 0"></app-erros-box>
        <app-tabela
            :itens="requisicaoComprometimentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <btn-inserir-rateio-requisicao
                        ref="inserirRateioRequisicao"
                        :requisicao="requisicao"
                        :erros="erros"
                        @inserirRateio="inserirRateio($event)"
                        v-if="permiteInserirRateio"
                    ></btn-inserir-rateio-requisicao>
                </b-button-group>
            </template>
            <template slot="valor" slot-scope="data">{{
                data.valor | currency
            }}</template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar-rateio-requisicao
                    :ref="`atualizarRateioRequisicao_${data.idComprometimento}`"
                    :requisicao="requisicao"
                    :comprometimento="data"
                    :erros="erros"
                    @atualizarRateio="atualizarRateio($event)"
                    v-if="permiteAtualizarRateio(data)"
                ></btn-atualizar-rateio-requisicao>
                <btn-excluir-rateio-requisicao
                    :comprometimento="data"
                    @excluirRateio="excluirRateio($event)"
                    v-if="permiteExcluirRateio(data)"
                ></btn-excluir-rateio-requisicao>
                <btn-visualizar-rateio-requisicao
                    :requisicao="requisicao"
                    :comprometimento="data"
                    v-if="permiteVisualizarRateio"
                ></btn-visualizar-rateio-requisicao>
                <btn-copiar
                    :contrato="requisicao.contrato"
                    :comprometimento="data"
                    v-if="permiteCopiar(data)"
                    @copiar="copiar($event)"
                ></btn-copiar>
                <btn-atualizar-movimento
                    :contrato="contrato"
                    :comprometimento="data"
                    :erros="erros"
                    v-if="permiteAtualizarRateio(data)"
                    @atualizarComprometimento="$emit('obterRequisicaoAtualizada')"
                ></btn-atualizar-movimento>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnInserirRateioRequisicao from './BtnInserirRateioRequisicao'
import RequisicoesServicos from './RequisicoesServicos'
import BtnAtualizarRateioRequisicao from './BtnAtualizarRateioRequisicao'
import BtnExcluirRateioRequisicao from './BtnExcluirRateioRequisicao'
import BtnVisualizarRateioRequisicao from './BtnVisualizarRateioRequisicao'
import BtnCopiar from './BtnCopiar'
import BtnAtualizarMovimento from './BtnAtualizarMovimento.vue'

export default {
    components: {
        BtnInserirRateioRequisicao,
        BtnAtualizarRateioRequisicao,
        BtnExcluirRateioRequisicao,
        BtnVisualizarRateioRequisicao,
        BtnCopiar,
        BtnAtualizarMovimento
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        requisicaoDisponivel: {
            type: Boolean,
            default: () => false
        },
        permiteOperacoes: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            requisicaoComprometimentos: [],
            comprometimentosSelecionados: [],
            erros: [],
            erros2: [],
            campos: [
                {
                    key: 'comprometimentoSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'vcTipoMovimento',
                    label: 'Movimento',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        marcarDesmarcarTodos() {
            if (this.comprometimentosSelecionados.length > 0) {
                this.comprometimentosSelecionados = []
            } else {
                this.comprometimentosSelecionados =
                    this.requisicaoComprometimentos
                        .filter((item) => {
                            return item.idSituacao === 1
                        })
                        .map((item) => {
                            return item.idComprometimento
                        })
            }
        },

        inserirRateio(rateio) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                itensComprometimento: rateio.itensRateios.map((item) => {
                    return {
                        idItemRequisicao: item.idItemRequisicao,
                        valorComprometimento: item.valorRateado
                    }
                }),
                rateios: rateio.rateios,
                historicoComprometimento: rateio.historicoComprometimento,
                dataComprometimento: rateio.dataComprometimento
            }
            RequisicoesServicos.inserirRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio inserido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$refs.inserirRateioRequisicao.fecharModal()
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarRateio(rateio) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: rateio.idComprometimento,
                itensComprometimento: rateio.itensRateios.map((item) => {
                    return {
                        idItemRequisicao: item.idItemRequisicao,
                        valorComprometimento: item.valorRateado
                    }
                }),
                rateios: rateio.rateios,
                historicoComprometimento: rateio.historicoComprometimento,
                dataComprometimento: rateio.dataComprometimento
            }
            RequisicoesServicos.atualizarRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$refs[
                                `atualizarRateioRequisicao_${rateioDto.idComprometimento}`
                            ].fecharModal()
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        excluirRateio(idComprometimento) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.excluirRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio excluido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros2 = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },


        copiar(idComprometimento) {
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.copiar(comprometimentoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Copia realizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.erros2 = response.errors
                        this.$emit('obterRequisicaoAtualizada')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        permiteAtualizarRateio(rateio) {
            return (
                (this.$temAcessoView('CONT-REQ-05') &&
                rateio.idSituacao == 1 &&
                this.permiteOperacoes) || this.requisicao.situacaoSolicitacao == 3
            )
        },

        permiteExcluirRateio(rateio) {
            return (
                (this.$temAcessoView('CONT-REQ-05') &&
                rateio.idSituacao == 1 &&
                this.permiteOperacoes) || this.requisicao.situacaoSolicitacao == 3
            )
        },

      

        permiteCopiar(rateio) {
            return (
                this.$temAcessoView('CONT-REQ-05') &&
                this.permiteOperacoes && 
                rateio.valor <= this.requisicao.saldoASerRateado
            )
        },
    },

    created() {},

    mounted() {
        this.requisicaoComprometimentos = [...this.requisicao.comprometimentos]
    },

    computed: {
        permiteInserirRateio() {
            return (
                (this.requisicao.saldoASerRateado > 0 &&
                this.$temAcessoView('CONT-REQ-05') &&
                this.permiteOperacoes) || this.requisicao.situacaoSolicitacao == 3
            )
        },

        permiteVisualizarRateio() {
            return this.$temAcessoView('CONT-REQ-02')
        }
    },

    watch: {
        requisicao() {
            this.requisicaoComprometimentos = [
                ...this.requisicao.comprometimentos
            ]
        }
    }
}
</script>
